"use server";

import { auth } from "../../lib/auth";
import { prisma } from "../../lib/prisma";
import { cookies } from "next/headers";
import { ACTIVE_ENTITY_COOKIE } from "../../lib/constants/cookies";

export async function ensureDefaultEntity() {
    const session = await auth();

    if (!session?.user?.id) {
        return;
    }

    const cookieStore = await cookies();

    // Si une entité est déjà sélectionnée, on ne fait rien
    if (cookieStore.has(ACTIVE_ENTITY_COOKIE)) {
        return;
    }

    // On cherche la première adhésion active de l'utilisateur
    const membership = await prisma.membership.findFirst({
        where: {
            userId: session.user.id,
            status: "ACTIVE",
        },
        select: {
            entityId: true,
        },
    });

    // Si une adhésion est trouvée, on définit le cookie
    if (membership?.entityId) {
        cookieStore.set(ACTIVE_ENTITY_COOKIE, membership.entityId, {
            httpOnly: true,
            sameSite: "lax",
            path: "/",
        });
    }
}